import { Flex, Icon, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import GenerateImageCTAIcon from '../../../../graphics/media-library/GenerateImageCTAIcon'

const NewButtonCTA = () => {
  const { t } = useTranslation()
  const history = useHistory()

  return (
    <Flex
      bg="appPaleGreyThree"
      direction="row"
      borderRadius="4px"
      padding="8px 12px"
      gap="4px"
      m="4px"
      cursor="pointer"
      onClick={() => {
        history.push('/media-library/generate-images')
      }}
    >
      <Flex direction="column" gap="4px">
        <Text fontWeight="600">
          {t('generate_images_gt', 'Generate images >')}
        </Text>
        <Text color="appSlate">
          {t('create_image_using_ai_prompts', 'Create image using text prompts')}
        </Text>
      </Flex>
      <Icon alignSelf="center" as={GenerateImageCTAIcon} w="64px" h="48px" />
    </Flex>
  )
}

export default NewButtonCTA
